import { Card, CardContent, Stack, styled, Table, TableContainer } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';

interface Props {
  content: JSX.Element;
  'data-testid'?: string;
  paginationComponent?: JSX.Element;
  stickyHeader?: boolean;
}

const StyledCardContent = styled(CardContent)({
  padding: 0,
  '&:last-child': { paddingBottom: 0 },
});

const StyledTableContainer = styled(TableContainer)({
  display: 'flex',
  flexDirection: 'column',
});

export const SearchResultsTableLayoutDesktop: FC<Props> = ({
  content,
  paginationComponent,
  stickyHeader,
  ...props
}) => (
  <Card data-testid={props['data-testid']}>
    <StyledCardContent>
      <StyledTableContainer>
        <Table
          aria-label="sticky table"
          component="div"
          size="small"
          stickyHeader={stickyHeader}
        >
          {content}
        </Table>
        {paginationComponent
          ? <Stack alignItems="center" marginY={1}>
            {paginationComponent}
          </Stack>
          : null
        }
      </StyledTableContainer>
    </StyledCardContent>
  </Card>
);
